<template>
  <div
    :id="type === 'image' ? 'video-cover' : 'video-output'"
    :class="type === 'audio' ? 'audio-cover' : ''"
    @mouseenter="showHandler = true"
    @mouseleave="showHandler = false"
  >
    <video
      v-if="type === 'video'"
      @loadedmetadata="videoLoaded"
      id="video"
      :src="src"
      controls
    ></video>
    <audio
      v-else-if="type === 'audio'"
      @loadedmetadata="videoLoaded"
      :src="src"
      controls
    >
      您的浏览器不支持audio标签
    </audio>
    <img v-else-if="type === 'image'" :src="src" class="avatar" />
    <template v-else />
    <div
      v-show="showHandler && showShadow"
      :class="['cover-bg', type === 'video' ? 'cover-top-30' : 'cover-top-0']"
    >
      <i
        v-if="type === 'image'"
        class="el-icon-zoom-in delete"
        @click.stop="showViewer = true"
      ></i>
      <i
        v-if="deleteable"
        class="el-icon-delete delete"
        @click.stop="deleteAction"
      ></i>
    </div>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[src]"
    />
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: {
    ElImageViewer,
  },
  props: {
    src: {
      type: String,
      default: "",
    },
    /* video/audio/image */
    type: {
      type: String,
      default: "video",
    },
    deleteable: {
      type: Boolean,
      default: true,
    },
    showShadow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showHandler: false,
      showViewer: false,
    };
  },
  methods: {
    deleteAction() {
      this.$emit("delete");
    },
    videoLoaded(e) {
      this.$emit("duration", parseInt(e.target.duration));
    },
    // 关闭图片预览
    closeViewer() {
      this.showViewer = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#video-output {
  position: relative;
  width: 260px;
  height: 160px;
  #video {
    object-fit: cover;
    width: 100%;
    height: 100%;
    outline: none;
  }
  .cover-bg {
    position: absolute;
    left: 0;
    width: 100%;
    height: 30%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;
    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
  .cover-top-0 {
    top: 0;
  }
  .cover-top-30 {
    top: 30%;
  }
}
#video-cover {
  width: 104px;
  height: 104px;
  position: relative;
  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;
    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
.avatar {
  width: 104px;
  height: 104px;
  display: block;
}
.audio-cover {
  width: 300px !important;
  height: auto !important;
}
</style>
